import R from 'ramda';
import $ from 'jquery';
import React from 'react';
import Promise from 'bluebird';
import Modal from 'react-bootstrap/lib/Modal';
import Alert from 'react-bootstrap/lib/Alert';
import autoBind from '../../modules/autoBind';
import { validations } from 'common';
import Spinner from '../../modules/Spinner.jsx';
import Table from '../users/Table.jsx';
import CreateConsultantForm from './CreateConsultantForm.jsx';
import EditConsultantForm from './EditConsultantForm.jsx';
import Pagination from 'react-bootstrap/lib/Pagination';

const pageSize = 20;
const columns = [
  { id: 'id', label: 'ID', maxWidth: 1 },
  { id: 'name', label: 'Nombre', maxWidth: 4 },
  { id: 'username', label: 'Correo', maxWidth: 4 },
  { id: 'company', label: 'Compañía', maxWidth: 4 },
  { id: 'jobposition', label: 'Puesto', maxWidth: 4 },
  { id: 'totallicenses', label: 'Lic. Totales', maxWidth: 1 },
  { id: 'usedlicenses', label: 'Lic. Usadas', maxWidth: 1 },
  { id: 'availablelicenses', label: 'Lic. Disponibles', maxWidth: 1 },
  { id: 'estatus', label: 'Estatus', maxWidth: 1 },
];

export default class Consultants extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);
    this.state = {
      creatingConsultant: false,
      editingConsultant: false,
      sortColumn: 'id',
      sortOrder: 'asc',
      selectedRow: null,
      toEditRow: null,
      editInfo: null,
      page: 0,
    };
  }
  componentDidMount() {
    this.fetchConsultants(this.props.resourceUrl);
  }
  render() {
    if (!this.state.consultantsResource && this.state.loadingConsultants) {
      return <Spinner />;
    }

    if (!this.state.consultantsResource && !this.state.loadingConsultants) {
      return <div>{this.state.errorMessage}</div>;
    }

    const resource = this.state.consultantsResource;
    const numOfPages = Math.ceil(resource.total / pageSize);
    const consultantIndices = R.range(this.state.page * pageSize, (this.state.page + 1) * pageSize);
    const selectedIndex = this.state.selectedRow ? this.state.selectedRow.index : null;
    const data = this.state.loadingConsultants ?
      [] :
      resource.consultants
      .map((consultant) => R.merge(consultant, { estatus: consultant.archived ? 'Desactivado' : 'Activado' }));

    return (
      <div>
        <button type='button' className='btn btn-success' style={{ marginRight: '10px' }} onClick={this.handleOpenCreateConsultantModal}>Crear Consultor</button>
        <If condition={this.state.selectedRow !== null}>
          <button type='button' className='btn btn-info' style={{ marginRight: '10px' }} onClick={ () => this.setState({ toEditRow: this.state.selectedRow })}>Editar Consultor</button>
        </If>
        <If condition={this.state.selectedRow !== null && data[selectedIndex].archived === false}>
          <button type='button' className='btn btn-danger' style={{ marginRight: '10px' }} onClick={this.handleOpenDeactivateUserModal}>Desactivar Consultor</button>
        </If>
        <If condition={this.state.selectedRow !== null && data[selectedIndex].archived === true}>
          <button type='button' className='btn btn-success' style={{ marginRight: '10px' }} onClick={this.handleOpenActivateUserModal}>Activar Consultor</button>
        </If>
        <If condition={this.state.newConsultant} >
          {this.renderCreateConsultantModal()}
        </If>
        <If condition={this.state.deleteUser} >
          {this.renderDeleteUserModal()}
        </If>
        <If condition={this.state.toEditRow !== null}>
          {this.renderEditConsultantModal()}
        </If>
        <Table 
          columns={columns} 
          sort={{ column: this.state.sortColumn, order: this.state.sortOrder }}
          data={data} 
          selectedIndex={selectedIndex} 
          onSort={this.handleSortChange}
          onRowClick={(event) => this.setState({ selectedRow: event })} 
          onRowDoubleClick={(event) => {
            this.setState({ toEditRow: event, editInfo: { totallicenses: 1 } });
          }}
        />
        <If condition={resource.total > pageSize}>
          <center>
            <Pagination 
              prev={this.state.page !== 0} 
              next={(this.state.page + 1) * pageSize <= resource.total} 
              first={this.state.page !== 0} 
              last={(this.state.page + 1) * pageSize <= resource.total} 
              bsSize="medium" 
              maxButtons={10} 
              items={Math.ceil(resource.total / pageSize)} 
              activePage={this.state.page + 1} 
              onSelect={this.handlePageChange} />
          </center>
        </If>
      </div>
    );
  }
  handleOpenDeactivateUserModal() {
    this.setState({ deleteUser: this.state.selectedRow.row, active: false });
  }
  handleOpenActivateUserModal() {
    this.setState({ deleteUser: this.state.selectedRow.row, active: true });
  }
  renderCreateConsultantModal() {
    const closeModal = () => this.setState({ newConsultant: null, modalErrorMessage: null })
    const consultantValidations = R.pick(['name'], validations);
    const validConsultantForm = () => R.is(Object, this.state.newConsultant) && validations.validateObject(consultantValidations, this.state.newConsultant);

    return (
      <Modal show={true} onHide={closeModal}>
        <Modal.Header closeButton>
          <Modal.Title>Crear Consultor</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <If condition={this.state.modalErrorMessage} >
            <Alert bsStyle="danger" onDismiss={() => this.setState({ modalErrorMessage: null })}>{this.state.modalErrorMessage}</Alert>
          </If>
          <CreateConsultantForm value={this.state.newConsultant} onChange={(newConsultant) => this.setState({ newConsultant })} />
        </Modal.Body>
        <Modal.Footer>
          <button type='button' className='btn btn-danger' onClick={closeModal}>Cancelar</button>
          <button type='submit' className='btn btn-success' onClick={this.handleCreateConsultant} disabled={!validConsultantForm() || this.state.creatingConsultant}>Crear</button>
        </Modal.Footer>
      </Modal>
    );
  }
  renderEditConsultantModal() {
    const closeModal = () => this.setState({ toEditRow: null, modalErrorMessage: null, editInfo: null })
    const consultantValidations = R.pick(['name'], validations);
    return (
      <Modal show={true} onHide={closeModal}>
        <Modal.Header closeButton>
          <Modal.Title>Editar Licencias</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <If condition={this.state.modalErrorMessage} >
            <Alert bsStyle="danger" onDismiss={() => this.setState({ modalErrorMessage: null })}>{this.state.modalErrorMessage}</Alert>
          </If>
          <EditConsultantForm value={this.state.editInfo} resourceUrl={this.props.consultantUrl.replace('{username}', this.state.toEditRow.row.username)} onChange={(editInfo) => this.setState({ editInfo })} />
        </Modal.Body>
        <Modal.Footer>
          <button type='button' className='btn btn-danger' onClick={closeModal}>Cancelar</button>
          <button type='submit' className='btn btn-success' onClick={this.handleEditConsultant} disabled={this.state.editingConsultant}>Guardar</button>
        </Modal.Footer>
      </Modal>
    );
  }
  handleSortChange({ column, order }) {
    const prevColumn = this.state.sortColumn, prevOrder = this.state.sortOrder;
    this.setState({ sortColumn: column, sortOrder: order });
    const url = this.state.consultantsResource._rels.sort.replace('{sort}', column).replace('{order}', order);
    this.fetchConsultants(url, this.state.page)
    .catch(() => this.setState({ sortColumn: prevColumn, sortOrder: prevOrder }))
  }
  handlePageChange(eventKey) {
    const page = eventKey - 1;
    this.fetchConsultants(this.state.consultantsResource._rels.getPage.replace('{pageNum}', page), page);
  }
  fetchConsultants(url, page = 0) {
    if (this.state.loadingConsultants) {
      return Promise.reject('Already fetching consultants.');
    }
    const prevPage = this.state.page;
    this.setState({ loadingConsultants: true, selectedRow: null, page });

    return Promise.resolve($.ajax({ url }))
    .then((consultantsResource) => this.setState({ consultantsResource }))
    .catch(() => this.setState({ page: prevPage, errorMessage: 'Hubo un error al crear el consultor.' }))
    .finally(() => this.setState({ loadingConsultants: false }));
  }
  handleOpenCreateConsultantModal() {
    this.setState({ newConsultant: { name: '', username: '', totallicenses: 10 } });
  }
  handleCreateConsultant(event) {
    event.preventDefault();
    this.setState({ creatingConsultant: true });
    return Promise.resolve($.ajax({
      url: this.props.resourceUrl,
      method: 'POST',
      data: this.state.newConsultant
    })).then(() => {
      this.setState({ newConsultant: null, modalErrorMessage: null });
      this.fetchConsultants(this.state.consultantsResource._rels.self, this.state.page);
    }).catch(() => this.setState({ modalErrorMessage: 'Ya existe un consultor con el mismo correo.' }))
    .finally(() => this.setState({ creatingConsultant: false }));
  }
  handleEditConsultant(event) {
    event.preventDefault();
    this.setState({ editingConsultant: true });
    return Promise.resolve($.ajax({
      url: this.props.consultantUrl.replace('{username}', this.state.toEditRow.row.username),
      method: 'PUT',
      data: this.state.editInfo
    })).then(() => {
      this.setState({ toEditRow: null, editInfo: null, modalErrorMessage: null });
      this.fetchConsultants(this.state.consultantsResource._rels.self, this.state.page);
    }).catch(() => this.setState({ modalErrorMessage: 'Hubo un error al crear el consultor.' }))
    .finally(() => this.setState({ editingConsultant: false }));
  }
  handleDeleteUser(event) {
    event.preventDefault();
    this.setState({ deletingUser: true });
     
    const url = this.state.consultantsResource._rels[this.state.selectedRow.index] + '/active';
    return Promise.resolve($.ajax({
      url: url,
      method: 'PATCH',
      data: { active: this.state.active },
    })).then(() => {
      this.setState({ deleteUser: null });
      this.fetchConsultants(this.state.consultantsResource._rels.self, this.state.page);
    }).finally(() => this.setState({ deletingUser: false }));
  }
  renderDeleteUserModal() {
    const closeModal = () => this.setState({ deleteUser: null })
    return (
      <Modal show={true} onHide={closeModal}>
        <Modal.Header closeButton>
          <If condition={this.state.active === true}>
            <Modal.Title>Desactivar Consultor</Modal.Title>
          </If>
          <If condition={this.state.active === false}>
            <Modal.Title>Activar Consultor</Modal.Title>
          </If>
        </Modal.Header>
        <Modal.Body>
        <If condition={this.state.active === false}>
          <span>¿Estás seguro de querer desactivar a {this.state.deleteUser.name}?</span>
        </If>
        <If condition={this.state.active === true}>
          <span>¿Estás seguro de querer activar a {this.state.deleteUser.name}?</span>
        </If>
        </Modal.Body>
        <Modal.Footer>
          <button type='button' className='btn btn-danger' onClick={closeModal}>Cancelar</button>
        <If condition={this.state.active === false}>
          <button type='submit' className='btn btn-success' onClick={this.handleDeleteUser} disabled={this.state.deletingUser}>Desactivar</button>
        </If>
        <If condition={this.state.active === true}>
          <button type='submit' className='btn btn-success' onClick={this.handleDeleteUser} disabled={this.state.deletingUser}>Activar</button>
        </If>
        </Modal.Footer>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App/consultants/Consultants.jsx